import {Base64Object} from '@coolcolduk/util';
import {getDownloadURL, ref, uploadString} from 'firebase/storage';
import {firebaseStorage} from '../../../config/firebase';

/**
 * Uploads a base64 file to Firebase Storage and returns the download URL.
 * @param base64Object - The file as base64 with name and type
 * @param path - Full storage path including filename and extension (e.g. "public/uid/avatar.jpg")
 * @returns Promise that resolves to the download URL
 */
export default async function uploadStorageBase64(base64Object: Base64Object, path: string): Promise<string> {
  const storageRef = ref(firebaseStorage, path);
  await uploadString(storageRef, base64Object.data, 'base64', {
    contentType: base64Object.type,
  });
  return getDownloadURL(storageRef);
}
